import { OnInit, Output, Input, Component, EventEmitter, ViewChild } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { TypeaheadMatch } from 'ngx-bootstrap';
import { TypeaheadConfig } from '../../typeahead-config.model';
import { AppDatatableConfigOptions } from '../../../datatable/models/config-options.model';
import { PaginationInfo } from '../../../../client-core/api-response-models/pagination-info.model';
import { UserService } from '../../../../client-core/services/user.service';
import { TacticService } from 'app/client-core/services/tactic.service';
import { TypeaheadLookupComponent } from '../../typeahead-lookup-component';

type Func<T, TResult> = (params?: any) => TResult;

@Component({
    selector: 'basic-typeahead',
    templateUrl: 'basic-typeahead.component.html'
})
export class BasicTypeaheadComponent implements OnInit {

    @Input()
    config: TypeaheadConfig;

    @Input()
    placeholder?: string;

    @Input()
    extraQueryParams?: any;

    @Output()
    onClicked = new EventEmitter<TypeaheadMatch>();

    @Output()
    onSelected = new EventEmitter<TypeaheadMatch>();

    @Input()
    disabled: boolean;

    @Input() IdColumnText: string;
    @Input() NameColumnText: string;
    @Input() clearAfterOnSelected: boolean;

    @Input() service: any;
    @Input() methodToCall: string;

    @Input() initialPlaceholder: string;
    @Input() itemsNotFoundText: string;
    @Input() additionalColumns: Array<any>;
    @ViewChild('typeaheadLookup') typeaheadLookup: TypeaheadLookupComponent;

    public list: Observable<any>;
    public listSearchTerm?: string;
    public listColumns: Observable<Array<any>>;
    public listConfig: Observable<AppDatatableConfigOptions>;
    public paginationInfo: Observable<PaginationInfo>;
    public paginationParams: any = {};
    public listSelected: TypeaheadMatch;
    public fetchObservable = 0;

    constructor(private tacticService: TacticService) {
    }

    ngOnInit() {
        const basicconfig = {
            displayField: 'name',
            noButton: true,
            buttonClass: 'btn btn-default',
            buttonIconClass: 'fa fa-search',
            buttonLoadingIconClass: 'fa fa-spinner fa-spin',
            noResultErrorMessage: this.itemsNotFoundText || 'Items not found.',
            suppressInlineErrorMessage: false,
            displayGroupedBy: undefined,
            placeHolder: this.initialPlaceholder || 'Search for items...',
            buttonText: '',
            inputLabel: '',
            dropup: false,
            clearAfterOnSelected: this.clearAfterOnSelected
        }
        this.config = basicconfig as TypeaheadConfig;
        
        let listColumns = [
            { prop: 'item.id', name: this.IdColumnText || 'Id', minWidth: 150 },
            { prop: 'item.name', name: this.NameColumnText || 'Name', minWidth: 250 }
        ] as Array<any>;

        if (this.additionalColumns) {
            listColumns = listColumns.concat(this.additionalColumns);
        }

        this.listColumns = Observable.of(listColumns);
        const listConfig = new AppDatatableConfigOptions();
        const rowGrouperLabelGetter = function (row: any) {
            return row.item.id;
        };

        listConfig.compact = true;
        listConfig.headerHeight = 30;
        listConfig.footerHeight = 30;
        listConfig.loadingIndicator = false;
        listConfig.rowGrouperHeight = 30;
        listConfig.rowGrouperAllowToggle = false;
        listConfig.rowGrouperLabelGetter = rowGrouperLabelGetter;
        listConfig.scrollbarHorizontal = false;
        listConfig.scrollbarVertical = false;
        this.listConfig = Observable.of(listConfig);
        this._refreshList();
    }

    private _refreshList(): void {
        const fun: Func<any, Observable<any>> = this.tacticService['getDocumentTypes'];
        // (this.tacticService['getDocumentTypes'] as Func<any, Observable<any>>)().subscribe(data => {
        // })
        this.list = Observable.create((observer: any) => {
            let queryParams = { };
            if (this.listSearchTerm) {
                queryParams['searchTerm'] = this.listSearchTerm;
            }

            queryParams = Object.assign({}, queryParams, this.paginationParams);
            queryParams = {
                pageSize: 20,
                ...queryParams,
                ...this.extraQueryParams
            }
            console.log('>>> observer', queryParams);
            (this.service[this.methodToCall] as Func<any, Observable<any>>)(queryParams)
                .subscribe(res => {
                    if (!res.hasError) {
                        if (res.data) {
                            const data = res.data;
                            const paginationInfo = PaginationInfo.createForApiPagedResponse(res.data);
                            this.paginationInfo = Observable.of(paginationInfo);
                            if (data.items && data.items.length > 0) {
                                observer.next(res.data.items);
                            } else {
                                observer.next([]);
                            }
                        } else {

                        }
                    }
                },
                (err: any) => {

                });
        });
    }

    toObservable(matches: Array<any>): Observable<any> {
        if (matches) {
            return Observable.of(matches);
        } else {
            return Observable.of([]);
        }
    }

    onTableAction(event: any = {}): void {
        if (event.pageIndex || event.pageIndex === 0) {
            this.paginationParams = event;
            if (event.sortBy) {
                this.paginationParams.sortBy = event.sortBy.replace(/item\./, '');
            }
            this.fetchObservable++;
        }
        console.log('>>> onTableAction', this.paginationParams);
    }

    onTableActionDone(event: any): void {
    }

    onRowActivate(event: any): void {
    }

    onRowSelect(event: any): void {
        if (event.selected && event.selected.length > 0) {
            const item = event.selected[0];
            this.listSelected = item;
        }
    }

    onSelectedCallback(event: any): void {
        this.onSelected.emit(event);
    }

    onSearchTermChanged(term): void {
        console.log(term);
        this.listSearchTerm = term;
        this.paginationParams.pageIndex = 0;
    }

    onButtonClicked(event: any): void {
        this.onClicked.emit(event);
    }

    clearText() {
        this.typeaheadLookup.clearText();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/typeahead/typeaheads/tactics/basic-typeahead.component.ts